import { uniqBy } from 'lodash-es';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { compareAsc, formatYMD, isBeforeDay, startOfDay } from '../../shared/dateFns';
import { State } from '../state';
import DateList from './DateList';

const datesSelector = createSelector(
    (state: State) => state.calendar.events.ids,
    (state: State) => state.calendar.events.dict,
    (ids, dict) => {
        const today = new Date();
        let dates = ids.map(id => startOfDay(dict[id].start)).filter(date => !isBeforeDay(date, today));
        dates = uniqBy(dates, d => formatYMD(d))
        return dates.sort(compareAsc);
    },
);

function AgendaView(): JSX.Element {
    const dates = useSelector(datesSelector);
    return <div>
        {dates.map(date => <DateList key={date.toString()} date={date} />)}
    </div>;
}

export default React.memo(AgendaView);
